module.exports = __webpack_public_path__ + "img/25.4e712d39.png";